import { useTheme } from "../context/ThemeContext";

const SparklesIcon = ({ active, color }) => {
  const { darkMode } = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3530_5516)">
        <path
          d="M11.25 1.5L11.654 3.29368C11.9968 4.81511 13.1849 6.00323 14.7063 6.34595L16.5 6.75L14.7063 7.15405C13.1849 7.49677 11.9968 8.68489 11.654 10.2063L11.25 12L10.846 10.2063C10.5032 8.68488 9.31511 7.49677 7.79368 7.15405L6 6.75L7.79368 6.34595C9.31511 6.00323 10.5032 4.81511 10.846 3.29368L11.25 1.5Z"
          stroke={active ? "white" : "#828282"}
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M5.25 9L5.53861 10.2812C5.7834 11.3679 6.63206 12.2166 7.7188 12.4614L9 12.75L7.7188 13.0386C6.63206 13.2834 5.78341 14.1321 5.53861 15.2188L5.25 16.5L4.96139 15.2188C4.71659 14.1321 3.86794 13.2834 2.7812 13.0386L1.5 12.75L2.7812 12.4614C3.86794 12.2166 4.71659 11.3679 4.96139 10.2812L5.25 9Z"
          stroke={active ? "white" : "#828282"}
          stroke-width="1.5"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3530_5516">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SparklesIcon;
